import axios from "axios";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { p2e, a2e } from "src/utility/Utils";
import { toast } from "react-toastify";
import { useAuth } from "src/hooks/useAuth";
import { MOZONO_BASE_API_URL } from "src/utility/Constants";
// import authConfig from 'src/configs/auth'

// const token = useJwt.getToken()
const instance = axios.create({
  // baseURL: 'https://apitest.mozono.ir/api',
  // baseURL: 'https://api-mozono.iran.liara.run/api',
  // baseURL: "https://api.amazonuae.ir/api",
  baseURL: MOZONO_BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const AxiosInterceptor = ({ children }) => {
  const router = useRouter();
  const { logout } = useAuth();

  useEffect(() => {
    const reqInterceptor = (config) => {
      // console.log(config)

      if (config.headers["Content-Type"] !== "multipart/form-data") {
        //   console.log('dif')
        config.data =
          config.data && JSON.parse(p2e(a2e(JSON.stringify(config.data))));
      }
      return config;
    };
    const reqErrorInterceptor = (req) => {
      return req;
    };
    const resInterceptor = (response) => {
      // console.log(response.data)
      if (
        response.data.status === "Token is Invalid" ||
        response.data.status === "Token is Expired" ||
        response.data.status === "Authorization Token not found"
      ) {
        // console.log(response.data)

        logout();
      }
      return response;
    };

    const errInterceptor = (error) => {
      // if (error.response.data.status === 'Token is Invalid'){
      //   logout()
      // }
      if (error.response.status !== 200 && error.response.status !== 500) {
        toast.error(error.response.data.message);
      }
      return Promise.reject(error);
    };

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    const reqinterceptor = instance.interceptors.request.use(
      reqInterceptor,
      reqErrorInterceptor
    );

    return () => {
      instance.interceptors.response.eject(interceptor);
      instance.interceptors.request.eject(reqinterceptor);
    };
  }, [router]);

  return children;
};
export { AxiosInterceptor };
export default instance;
